import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content while preserving rich-text formatting, Tailwind/CSS classes,
 * inline styling, and authorized embed frames (YouTube, Google Maps).
 *
 * @param dirtyHtml - The raw HTML string from CMS or API
 * @returns The sanitized safe HTML string ready for dangerouslySetInnerHTML
 */
export const sanitizeHtml = (dirtyHtml?: string | null): string => {
    if (!dirtyHtml) return '';

    // Replace non-breaking space entities for uniform rendering if needed
    const formatted = dirtyHtml.replace(/&nbsp;/g, ' ');

    return DOMPurify.sanitize(formatted, {
        ADD_TAGS: ['iframe', 'style'],
        FORCE_BODY: true,
        ADD_ATTR: [
            'allow',
            'allowfullscreen',
            'frameborder',
            'scrolling',
            'target',
            'loading',
            'referrerpolicy',
            'class',
            'style',
        ],
    });
};
